import React from "react";
import PerformanceServices from "@/components/PerformanceServices";

export default function PerformancePage() {
  return <PerformanceServices />;
}
